import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  CompanyContractClosingDateResponse,
  CompanyContractClosingDateType,
} from '@/features/privateCompanies/types/companyContractClosingDate.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UseCompanyContractClosingDateProps = {
  id: string
}

type UseCompanyContractClosingDateType = (
  props: UseCompanyContractClosingDateProps,
) => UseQueryResult<CompanyContractClosingDateType, unknown>

export const useCompanyContractClosingDate: UseCompanyContractClosingDateType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CompanyContractClosingDateResponse, unknown, CompanyContractClosingDateType>({
    queryKey: ['companyContractClosingDate', id],
    queryFn: () => {
      return privateAxios.get(`/client/contracts/${id}/show_closing_day`)
    },
    select: (data) => data?.data?.data,
  })
}
